import { useEffect, useCallback, useState } from 'react';
import { authClient } from '@/lib/auth-client';
import { socketService } from '@/services/socket/socketService';
import { useOnboardingStore } from '@/stores/onboardingStore';

export function useSocket() {
  const { data: session } = authClient.useSession();
  const { isConnected, connectionError } = useOnboardingStore(state => state.socket);
  const [connectionId, setConnectionId] = useState(0);

  useEffect(() => {
    const token = session?.session?.token;
    if (!token) return;

    socketService.addConsumer();
    socketService.connect(token, {
      onConnect: () => {
        useOnboardingStore.getState().setSocketConnected(true);
        useOnboardingStore.getState().setSocketError(null);
        setConnectionId(prev => prev + 1);
      },
      onDisconnect: () => {
        useOnboardingStore.getState().setSocketConnected(false);
      },
      onError: (msg: string) => {
        useOnboardingStore.getState().setSocketConnected(false);
        useOnboardingStore.getState().setSocketError(msg);
      },
    });

    return () => {
      socketService.removeConsumer();
    };
  }, [session?.session?.token]);

  const on = useCallback(<T = unknown>(event: string, callback: (data: T) => void) => {
    socketService.on(event, callback);
  }, []);

  const off = useCallback(<T = unknown>(event: string, callback?: (data: T) => void) => {
    socketService.off(event, callback);
  }, []);

  const emit = useCallback((event: string, data?: unknown) => {
    socketService.emit(event, data);
  }, []);

  return { isConnected, connectionError, connectionId, on, off, emit };
}
